// frontend/src/utils/referralCapture.ts
//
// Captures ?ref=... from ANY landing URL - the query-param twin of the
// /bar/<ref> path capture in BarLandingPage. This is what makes shared and
// copy-pasted links attributable no matter which page they point at.
// First-touch wins (enforced by saveReferral). The param is deliberately
// left in the URL so a re-shared browser URL keeps carrying attribution.

import { recordReferralScan } from '@/api/referrals';
import { mixpanelTrack } from '@/services/mixpanel';
import { isUserRef, normalizeRef, saveReferral } from './referral';

export const captureReferralParam = (): void => {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = normalizeRef(params.get('ref'));
    if (!ref) return;
    saveReferral(ref);
    // Once per ref per browser session: reloads/back-nav of the same URL must
    // not multiply scan rows and landing events (would inflate K_share).
    const dedupKey = `ref_landed_${ref}`;
    try {
      if (sessionStorage.getItem(dedupKey)) return;
      sessionStorage.setItem(dedupKey, '1');
    } catch {
      // storage unavailable - fall through and record once per load
    }
    recordReferralScan(ref);
    mixpanelTrack('Referral Link Landed', {
      'Ref': ref,
      'Ref Type': isUserRef(ref) ? 'user' : 'other',
      'Landing Path': window.location.pathname,
    });
  } catch {
    // attribution is best-effort - never break the landing
  }
};
